import axios from 'axios';
import Links from '../constants/Links';

const links = Links.pgBoardResultReports;

export default {
  list: () => axios.get(links.all),
  programmeTypes: () => axios.get(links.programmeTypes),
  detail: id => axios.get(links.detail(id)),
  create: data => axios.post(links.all, data),
  update: (id, data) => axios.put(links.detail(id), data),
  searchStudents: (id, programmeTypeId, query) => axios.get(links.studentSearch(id), {
    params: { programmeTypeId, query }
  }),
  addStudent: (id, studentId) => axios.post(links.student(id, studentId)),
  updateStudent: (id, studentId, data) => axios.put(links.student(id, studentId), data),
  removeStudent: (id, studentId) => axios.delete(links.student(id, studentId)),
  clearStudents: id => axios.delete(links.students(id)),
  download: id => axios.get(links.pdf(id), { responseType: 'blob' }),
  downloadRosterReview: id => axios.get(links.rosterPdf(id), { responseType: 'blob' }),
  template: id => axios.get(links.template(id), { responseType: 'blob' }),
  import: (id, file) => {
    const form = new FormData();
    form.append('file', file);
    return axios.post(links.import(id), form);
  }
};
